import type { CustomFieldType, FieldId, FormField, PublicConfig } from './types';

const INPUT_TYPES: Record<FieldId, string> = {
  firstName: 'text',
  lastName: 'text',
  email: 'email',
  mobilePhone: 'tel',
  birthdate: 'date',
};

const AUTOCOMPLETE: Record<FieldId, string> = {
  firstName: 'given-name',
  lastName: 'family-name',
  email: 'email',
  mobilePhone: 'tel',
  birthdate: 'bday',
};

const CUSTOM_INPUT_TYPES: Record<CustomFieldType, string> = {
  string: 'text',
  number: 'number',
  dollars: 'number',
  date: 'date',
  datetime: 'datetime-local',
};

/** The enabled platform fields followed by the contact custom fields, in form order. */
export const formFields = (settings: PublicConfig['settings']): FormField[] => [
  ...settings.fields.filter(field => field.enabled).map(field => ({
    name: field.id,
    label: field.label,
    placeholder: field.placeholder,
    required: field.required,
    inputType: INPUT_TYPES[field.id],
    autocomplete: AUTOCOMPLETE[field.id],
    fieldId: field.id,
  })),
  ...settings.customFields.map(field => ({
    name: field.name,
    label: field.label,
    placeholder: field.placeholder,
    required: field.required,
    inputType: CUSTOM_INPUT_TYPES[field.fieldType],
    autocomplete: 'off',
    customFieldType: field.fieldType,
  })),
];
